<template>
  <div>
    <v-select
      v-model="item.id_menu"
      :items="menus"
      label="Menu*"
      outlined
      item-text="descricao"
      item-value="id"
    />

    <v-text-field
      v-model="item.descricao"
      label="Descrição do sub menu*"
      clearable
      autofocus
      outlined
    />

    <v-text-field
      v-model="item.url"
      label="Url do sub menu*"
      clearable
      outlined
    />
  </div>
</template>

<script>
import { buscarMenusConfiguracaoMenuParametrizacao } from '../../../Api';
import TextFieldFormatadorDeValor from "@/components/utils/TextFieldFormatadorDeValor.vue";

export default {
  components: {
    TextFieldFormatadorDeValor
  },
  model: {
    prop: 'item',
    event: 'change-item'
  },
  props: {
    item: { type: Object },
    dialog: { type: Boolean },
  },
  data: () => ({
    menus: []
  }),
  created() {
    setTimeout(() => this.buscarMenus(), 500);
  },
  watch: {
    dialog(valor) {
      if (valor) setTimeout(() => this.buscarMenus(), 500);
    }
  },
  methods: {
    buscarMenus() {
      this.$store.dispatch(
        'loading/addRequisicao',
        buscarMenusConfiguracaoMenuParametrizacao()
          .then((menus) => this.menus = menus)
          .catch(() => this.Helpers.logout())
      )
    },
  }
}
</script>

<style>

</style>
